import { type FC } from "react";
import { RadioButton } from "@root/shared/components/RadioButton";
import { TextArea } from "@root/shared/components/TextArea";
import { useFormContext } from "react-hook-form";
import { Label } from "@root/shared/components/Label";
import * as styles from "./styles.css";

type Props = {
  radioInputValue: string;
  text: string;
  selectedReason: string;
  handleRadioChange: (value: string) => void;
  handleTextAreaChange: () => void;
};

export const FormInput: FC<Props> = ({
  radioInputValue,
  text,
  selectedReason,
  handleRadioChange,
  handleTextAreaChange,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div key={radioInputValue} className={styles.item}>
      <label htmlFor={radioInputValue} className={styles.formLabel}>
        <RadioButton
          id={radioInputValue}
          {...register("reason")}
          value={radioInputValue}
          className={styles.radioButton}
          hasError={!!errors.reason}
          checked={selectedReason === radioInputValue}
          onChange={(event) => handleRadioChange(event.target.value)}
        />
        {text}
      </label>
      {radioInputValue === "other" && (
        <>
          <div className={styles.textAreaLabelWrapper}>
            <span className={styles.textAreaLabel}>理由の詳細</span>
            {selectedReason === "other" ? (
              <Label theme="red" size="small">
                必須
              </Label>
            ) : (
              <Label theme="lightGray" size="small">
                任意
              </Label>
            )}
          </div>
          <TextArea
            {...register("description")}
            placeholder="理由をご記入ください。"
            className={styles.textArea}
            hasError={!!errors.description}
            onChange={handleTextAreaChange}
          />
          {errors.description && (
            <p className={styles.descriptionErrorMessage}>{errors.description.message}</p>
          )}
        </>
      )}
    </div>
  );
};
